import loadNetSim from './init/loadNetSim';
import loadAppOptions from '@cdo/apps/code-studio/initApp/loadApp';

loadAppOptions().then(loadNetSim);
